import(/* webpackMode: "eager" */ "/app/apps/next/app/(tabs)/profile/page.tsx");
